import PropTypes from 'prop-types';
import React from 'react';
import { propTypesGatsbyImage } from '../../../shared/constants/Proptypes';

import * as S from './Picture.styles';

export const Picture = ({
  altText,
  center,
  height,
  imageUrl,
  imageObject,
  isNotLazy,
  radius,
  width,
  background,
}) => {
  if (!imageObject && !imageUrl) {
    return null;
  }

  const defaultProps = {
    alt: altText,
    loading: isNotLazy ? 'eager' : 'lazy',
    radius,
    width,
  };

  return (
    <S.PictureContainer
      background={background}
      center={center}
      height={height}
      radius={radius}
      width={width}
    >
      {imageObject ? (
        <S.StyledGatsbyPicture image={imageObject} {...defaultProps} />
      ) : (
        <S.StyledPicture
          as='img'
          data-object-fit='cover'
          height='100%'
          src={imageUrl}
          {...defaultProps}
        />
      )}
    </S.PictureContainer>
  );
};

Picture.propTypes = {
  /**
   * Set an alt-text to the picture.
   */
  altText: PropTypes.string,
  /**
   * Set a background color to the image.
   */
  background: PropTypes.string,
  /**
   * Image center
   */
  center: PropTypes.bool,
  /**
   * Image height.
   */
  height: PropTypes.string,
  /**
   * Image object
   */
  imageObject: PropTypes.shape(propTypesGatsbyImage),
  /**
   * Image url, any size.
   */
  imageUrl: PropTypes.string,
  /**
   * Check if img is lazy
   */
  isNotLazy: PropTypes.bool,
  /**
   * Set a border radius to the image.
   */
  radius: PropTypes.string,
  /**
   * Image width.
   */
  width: PropTypes.string,
};

Picture.defaultProps = {
  altText: 'picture',
  center: false,
  isNotLazy: false,
};
